var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionsTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.794 2.29279C14.9815 2.10532 15.2358 2 15.501 2C15.7662 2 16.0205 2.10532 16.208 2.29279L17.711 3.79579C17.8985 3.98331 18.0038 4.23762 18.0038 4.50279C18.0038 4.76795 17.8985 5.02226 17.711 5.20979L16.208 6.71279C16.0205 6.90026 15.7662 7.00557 15.501 7.00557C15.2358 7.00557 14.9815 6.90026 14.794 6.71279L13.29 5.20979C13.1025 5.02226 12.9972 4.76795 12.9972 4.50279C12.9972 4.23762 13.1025 3.98331 13.29 3.79579L14.794 2.29279ZM4.5 18.0028H6V14.0028H2V15.5028C2 16.1658 2.26339 16.8017 2.73223 17.2706C3.20107 17.7394 3.83696 18.0028 4.5 18.0028ZM6 9.00279V13.0028H2V9.00279H6ZM11 13.0028H7V9.00279H11V13.0028ZM7 14.0028H11V18.0028H7V14.0028ZM12 9.00279V13.0028H16V9.00279H12ZM12 14.0028H16V15.5028C16 16.1658 15.7366 16.8017 15.2678 17.2706C14.7989 17.7394 14.163 18.0028 13.5 18.0028H12V14.0028ZM2 8.00279H6V4.00279H4.5C3.83696 4.00279 3.20107 4.26618 2.73223 4.73502C2.26339 5.20386 2 5.83975 2 6.50279V8.00279ZM7 8.00279V4.00279H11V8.00279H7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsTab);
export default __webpack_public_path__ + "static/media/SolutionsTab.4010996cd4ccef2bd5cd33e7461a9644.svg";
export { ForwardRef as ReactComponent };